<p-blockUI [blocked]="isLoadingResults">
  <div class="loading-overlay-center">
    <img src="../../../../../assets/images/loading.gif" alt="" width="300px" height="200px">
  </div>
</p-blockUI>

<form class="head" [formGroup]="form" id="form-filter">
  <div class="filter-form">

    <div class="filter-form__row">
      <!-- Fecha de vuelo -->
      <mat-form-field appearance="outline" class="filter-form__field">
        <mat-label>Fecha de vuelo</mat-label>
        <mat-date-range-input [rangePicker]="picker" autocomplete="off">
          <input formControlName="dateFrom" matStartDate matInput placeholder="Fecha inicio" autocomplete="off" />
          <input formControlName="dateTo" matInput matEndDate placeholder="Fecha Fin" autocomplete="off" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <!-- Fecha de proceso -->
      <mat-form-field appearance="outline" class="filter-form__field">
        <mat-label>Fecha de proceso</mat-label>
        <mat-date-range-input [rangePicker]="pickerProcess" autocomplete="off">
          <input matInput formControlName="processDateFrom" matStartDate placeholder="Fecha inicio" />
          <input matInput formControlName="processDateTo" matEndDate placeholder="Fecha fin" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="pickerProcess"></mat-datepicker-toggle>
        <mat-date-range-picker #pickerProcess></mat-date-range-picker>
      </mat-form-field>

      <mat-form-field *ngIf="this.rol == 'solicitante'" class="filter-form__field" appearance="outline">
        <mat-label>Solicitante</mat-label>
        <input type="text" matInput [value]="this.emailUser" disabled>
      </mat-form-field>

      <mat-form-field *ngIf="this.rol == 'admin'" class="filter-form__field" appearance="outline">
        <mat-label>Solicitante</mat-label>
        <input type="text" placeholder="Selecciona un solicitante" aria-label="Solicitante" matInput
          formControlName="applicationUser" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="getOptionText">
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
            {{ option.usuario }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="filter-form__row">
      <mat-form-field appearance="outline" class="filter-form__field">
        <mat-label>Estado de solicitud</mat-label>
        <mat-select formControlName="status">
          <mat-option *ngFor="let estado of estados" [value]="estado">{{ estado }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="showPNRFilter" appearance="outline" class="filter-form__field">
        <mat-label>PNR</mat-label>
        <input type="text" matInput formControlName="pnr" placeholder="PNR">
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-form__field">
        <mat-label>Cuenta</mat-label>
        <input type="text" matInput formControlName="cuenta" placeholder="Cuenta">
      </mat-form-field>

      <div *ngIf="!showPNRFilter" class="filter-form__cell--empty" aria-hidden="true"></div>
    </div>

    <div class="filter-form__actions example-button-row">
      <button class="width-buttons" mat-flat-button color="accent" [disabled]="!form.valid"
        (click)="sendRequest()" id="btn-consultar">CONSULTAR</button>
      <button class="width-buttons" mat-flat-button color="primary" [disabled]="!form.valid"
       (click)="sendRequestCSV()">
        <mat-icon>save</mat-icon> DESCARGAR
      </button>
    </div>

  </div>

</form>
